import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconDecrease$1 = /*@__PURE__*/ proxyCustomElement(class WppIconDecrease extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-decrease", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.15575 2.48199C3.51093 2.26888 3.97163 2.38406 4.18474 2.73924L5.21626 4.45845H6.87495C7.1384 4.45845 7.38253 4.59667 7.51807 4.82257L8.54959 6.54178H10.2083C10.4717 6.54178 10.7159 6.68 10.8514 6.90591L11.8829 8.62511H13.125C13.3239 8.62511 13.5146 8.70413 13.6553 8.84478L16.125 11.3145V9.79178C16.125 9.37757 16.4607 9.04178 16.875 9.04178C17.2892 9.04178 17.625 9.37757 17.625 9.79178V13.1251C17.625 13.5393 17.2892 13.8751 16.875 13.8751H13.5416C13.1274 13.8751 12.7916 13.5393 12.7916 13.1251C12.7916 12.7109 13.1274 12.3751 13.5416 12.3751H15.0643L12.8143 10.1251H11.4583C11.1948 10.1251 10.9507 9.98689 10.8152 9.76099L9.78364 8.04178H8.12495C7.8615 8.04178 7.61737 7.90356 7.48183 7.67765L6.45031 5.95845H4.79162C4.52817 5.95845 4.28404 5.82022 4.1485 5.59432L2.8985 3.51099C2.68539 3.1558 2.80056 2.6951 3.15575 2.48199ZM3.54162 6.54178C3.95583 6.54178 4.29162 6.87757 4.29162 7.29178V16.8751C4.29162 17.2893 3.95583 17.6251 3.54162 17.6251C3.1274 17.6251 2.79162 17.2893 2.79162 16.8751V7.29178C2.79162 6.87757 3.1274 6.54178 3.54162 6.54178ZM6.87495 8.62511C7.28916 8.62511 7.62495 8.9609 7.62495 9.37511V16.8751C7.62495 17.2893 7.28916 17.6251 6.87495 17.6251C6.46074 17.6251 6.12495 17.2893 6.12495 16.8751V9.37511C6.12495 8.9609 6.46074 8.62511 6.87495 8.62511ZM10.2083 10.7084C10.6225 10.7084 10.9583 11.0442 10.9583 11.4584V16.8751C10.9583 17.2893 10.6225 17.6251 10.2083 17.6251C9.79407 17.6251 9.45828 17.2893 9.45828 16.8751V11.4584C9.45828 11.0442 9.79407 10.7084 10.2083 10.7084ZM13.5416 14.8751C13.9558 14.8751 14.2916 15.2109 14.2916 15.6251V16.8751C14.2916 17.2893 13.9558 17.6251 13.5416 17.6251C13.1274 17.6251 12.7916 17.2893 12.7916 16.8751V15.6251C12.7916 15.2109 13.1274 14.8751 13.5416 14.8751ZM16.125 16.0418C16.125 15.6276 16.4607 15.2918 16.875 15.2918C17.2892 15.2918 17.625 15.6276 17.625 16.0418V16.8751C17.625 17.2893 17.2892 17.6251 16.875 17.6251C16.4607 17.6251 16.125 17.2893 16.125 16.8751V16.0418Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-decrease-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-decrease", "wpp-icon-decrease-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-decrease-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-decrease-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconDecrease$1);
      }
      break;
  } });
}

const WppIconDecrease = WppIconDecrease$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconDecrease, defineCustomElement };
